module.exports = __webpack_public_path__ + "static/media/10.Oil Extraction Machine.05597a50.jpg";